"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncLoadingModal;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

function AsyncLoadingModal(_ref) {
  var expectedWidth = _ref.expectedWidth,
      _ref$expectedHeight = _ref.expectedHeight,
      expectedHeight = _ref$expectedHeight === void 0 ? 0 : _ref$expectedHeight,
      _ref$loaderSize = _ref.loaderSize,
      loaderSize = _ref$loaderSize === void 0 ? 'small' : _ref$loaderSize;
  return _react.default.createElement(_UIModal.default, {
    centered: true,
    width: expectedWidth
  }, _react.default.createElement(_UIDialogHeader.default, null), _react.default.createElement("div", {
    className: "align-center flex-column"
  }, _react.default.createElement(_UILoadingSpinner.default, {
    minHeight: expectedHeight,
    size: loaderSize
  })));
}

AsyncLoadingModal.propTypes = {
  expectedWidth: _propTypes.default.number,
  expectedHeight: _propTypes.default.number,
  loaderSize: _propTypes.default.string
};
module.exports = exports.default;